import {
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate';

import {
  mapMutations,
} from 'vuex';

export default {
  name: 'CustomInput',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    name: '',
    label: '',
    property: '',
    modelState: '',
    rules: '',
    disabled: false,
    placeholder: '',
    mask: '',
    isVehicle: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    changed: false,
  }),
  computed: {
    model: {
      get() {
        return this.modelState;
      },
      set(newModel) {
        if (newModel != null) {
          const changeDataStateObject = {
            state: newModel,
            property: this.property,
          };
          if (this.isVehicle) {
            this.setVehicleDataMutation(changeDataStateObject);
          } else {
            this.setPersonalDataMutation(changeDataStateObject);
          }
        }

        return newModel;
      },
    },
    showMask() {
      return this.changed && (typeof this.mask !== 'undefined');
    },
  },
  methods: {
    ...mapMutations('appointment', {
      setPersonalDataMutation: 'SET_PERSONALDATA',
      setVehicleDataMutation: 'SET_VEHICLEDATA',
    }),
    triggerChange() {
      this.changed = true;
    },
  },
};
